var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_51",
    "data-name": "Group 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.333,
    height: 84.95,
    viewBox: "0 0 63.333 84.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 63.333,
    height: 84.95,
    fill: "#e68242"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M55.7,189.189l2.216-12.073a4.868,4.868,0,0,0-1.865-3.5c-1.824-1.37-3.322-.934-5.367-.6a160.221,160.221,0,0,0-16.235,3.131,4.253,4.253,0,0,0-3.056,5.715c.552,1.49,1.865,2.427,2.907,3.545l-2.143,2.108c-3.642-2.518-6.477-9.192-11.778-5.888l-7.922,7.94c-.745.428-3.41-.079-4.351-.28-11.212-2.405-9.114-15.89-3.76-22.954C13.9,153.727,30.78,159.51,44.365,158.2A20.922,20.922,0,0,1,63.27,180.8a8.778,8.778,0,0,1-7.569,8.384",
    transform: "translate(0 -119.053)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M71.265.1C91.346-1.845,99.213,24.321,82.374,33.713a18.07,18.07,0,0,1-26.509-19.5C57.374,7.006,63.847.822,71.265.1",
    transform: "translate(-41.793 0)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M79.521,230.281a1.594,1.594,0,0,1,1.727,1.672l-3.689,18.46a1.16,1.16,0,0,1-.976.424c-1.191-.177-4.682-4.576-5.024-4.576L59.85,257.974a1.99,1.99,0,0,1-1.9.418c-1.358-.315-6.525-6.816-8.191-7.872l-.525.154-6.627,6.84c-.87.749-1.586,1.31-2.782.743-.8-1.24-4.08-3.524-4.553-4.668a1.537,1.537,0,0,1,.228-1.706l13.414-13.329a1.631,1.631,0,0,1,1.8.14l7.9,7.734,6.57-6.534c-.8-1.085-4.588-3.969-4.535-5.168a1.619,1.619,0,0,1,1.361-1.145c5.5-1.513,11.913-1.889,17.5-3.3",
    transform: "translate(-26.463 -173.539)",
    fill: "#e68242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalGrowth);
export default __webpack_public_path__ + "static/media/personal_growth.201a7a78656c7229b87047a3b8534c2d.svg";
export { ForwardRef as ReactComponent };